import { UiTranslatorDictionaryItem } from "./ui/model/UiTranslatorDictionaryItem";

/**
 * Stores the state of editable i18n dictionary and related translation methods.
 */
export class UiTranslatorService {
  private dictionary: Array<UiTranslatorDictionaryItem> = [];
  /**
   * Get dictionary
   * @returns UiTranslatorDictionaryItem array
   */
  public getDictionary() {
    return this.dictionary;
  }

  /**
   * Adds item to dictionary
   * @param item item to be added to dictionary
   */
  public addToDictionary(item: UiTranslatorDictionaryItem) {
    this.dictionary.push(item);
  }
}